/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Learningdeficiencies1Inputs */

const de__field_learningdeficiencies1 = /** @type {(inputs: _Field_Learningdeficiencies1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Einverständnis Lernschwächen`)
};

/**

* @param {_Field_Learningdeficiencies1Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _field_learningdeficiencies1 = /** @type {((inputs?: _Field_Learningdeficiencies1Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Learningdeficiencies1Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return de__field_learningdeficiencies1(inputs)
});
export { _field_learningdeficiencies1 as "_field_learningDeficiencies" }